import React, { useEffect } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import "./ScholarshipDetail.css";
import scholarships from "../../assets/data/becas_actualizadas.json";

const categoryColors = {
  "General / Interdisciplinaria": "#7c3cff",
  "Artes y Diseño": "#4f9fd9",
  "Ciencias Sociales y Humanidades": "#d68a3f",
  "Educación y Pedagogía": "#e65c79",
  "Ingeniería, Ciencia y Tecnología": "#3b82f6",
  "Negocios, Economía y Finanzas": "#b8942e",
  "Salud y Medicina": "#c65bea",
};

export default function ScholarshipDetail() {
  const { idx } = useParams();
  const navigate = useNavigate();
  const index = Number(idx);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  if (isNaN(index) || index < 0 || index >= scholarships.length) {
    navigate("/becas", { replace: true });
    return null;
  }

  const beca = scholarships[index];
  const categoryColor = categoryColors[beca["Categoría"]] || "#7c3cff";

  function formatEducationLevels(raw = "") {
    return raw
      .split(",")
      .map((item) => item.replace(/_/g, " ").trim())
      .map((item) => item.charAt(0).toUpperCase() + item.slice(1).toLowerCase())
      .join(", ");
  }

  return (
    <main className="sd-page">
      <article className="sd-detail">
        <header className="sd-header">
          <div className="sd-header__top">
            <Link to="/becas" className="sd-back-link">
              ← Volver a la lista
            </Link>

            <span
              className="sd-category"
              style={{ "--category-color": categoryColor }}
            >
              {beca["Categoría"]}
            </span>
          </div>

          <h1>{beca["Nombre de la Beca"]}</h1>

          {beca["Institución Otorgante"] && (
            <p>
              Una oportunidad otorgada por{" "}
              <strong>{beca["Institución Otorgante"]}</strong>.
            </p>
          )}
        </header>

        <figure className="sd-image-wrapper">
          <img
            src={beca["Image URL"]}
            alt={beca["Nombre de la Beca"]}
            className="sd-image"
          />
        </figure>

        <section className="sd-section sd-section--details">
          <h2>Detalles</h2>

          <div className="sd-detail-grid">
            {beca["Institución Otorgante"] && (
              <div className="sd-detail-item">
                <span>Institución</span>
                <strong>{beca["Institución Otorgante"]}</strong>
              </div>
            )}

            {beca["Nivel Educativo"] && (
              <div className="sd-detail-item">
                <span>Nivel educativo</span>
                <strong>
                  {formatEducationLevels(beca["Nivel Educativo"])}
                </strong>
              </div>
            )}

            {beca[
              "Tipo de Beca (descripcion detallada que se mostraria en el website)"
            ] && (
              <div className="sd-detail-item">
                <span>Tipo de beca</span>
                <strong>
                  {
                    beca[
                      "Tipo de Beca (descripcion detallada que se mostraria en el website)"
                    ]
                  }
                </strong>
              </div>
            )}

            {beca["Período de Solicitud"] && (
              <div className="sd-detail-item">
                <span>Período de solicitud</span>
                <strong>{beca["Período de Solicitud"]}</strong>
              </div>
            )}
          </div>
        </section>

        {beca["Descripción"] && (
          <section className="sd-section">
            <h2>Descripción</h2>
            <p>{beca["Descripción"]}</p>
          </section>
        )}

        {beca["Beneficios"] && (
          <section className="sd-section">
            <h2>Beneficios</h2>
            <p>{beca["Beneficios"]}</p>
          </section>
        )}

        {beca["Requisitos"] && (
          <section className="sd-section">
            <h2>Requisitos</h2>
            <p>{beca["Requisitos"]}</p>
          </section>
        )}

        {beca["URL"] && (
          <div className="sd-cta">
            <a
              href={beca["URL"]}
              target="_blank"
              rel="noopener noreferrer"
              className="sd-official-link"
            >
              Ir al sitio oficial
            </a>
          </div>
        )}
      </article>
    </main>
  );
}
